<template>
  <div class="base-pre page">
    <navigation :customClickEvent="true" @click="detention">拿额度，仅需两步</navigation>

    <!-- 标题 -->
    <section class="title">
      <h1>
        <img src="./images/step_02.png" />
        <span>补充资料</span>
      </h1>
      <h2>
        为确保资金及时到账，请确认您的借款信息。为保证您的信息及资金安全，请本人操作，勿将信息泄露给他人。
      </h2>
    </section>

    <!-- 表单 -->
    <form ref="form" class="form">
      <div class="card-title">
        <img src="./images/base_1.png" />
        <span>借款信息</span>
      </div>

      <div class="card-panel">
        <div class="form-item underline-un-focus amt-input" @click="openKeyboard" v-if="replenish.includes('loanAmt')">
          <nd-input name="loanAmt" v-model="form.loanAmt" label="借款金额" placeholder="请填写金额" text-align="right">
          </nd-input>
        </div>
        <div class="form-item underline-un-focus" v-if="replenish.includes('loanUsage')">
          <nd-choose name="loanUsage" label="借款用途" :valueKey="['key', 'description']" :data="dictionary.loanPurpose" v-model="form.loanUsage">
          </nd-choose>
        </div>

        <div class="form-item underline-un-focus" v-if="replenish.includes('loanTerm')">
          <nd-choose name="loanTerm" label="分期期数" :valueKey="['key', 'description']" :data="termList" v-model="form.loanTerm">
          </nd-choose>
        </div>
        <nd-cell v-if="process === 'CREDIT_BANK_INFO'" class="form-cell" title="收款银行卡" :text="`${cardText}`" @click="goBankCard" data-sensors-click></nd-cell>
      </div>
    </form>
    <nd-button class="submit-btn" data-sensors-click :disabled="!!submitDisabled" :loading="loading" @click="submitBaseInfo">提交资料，立获额度</nd-button>
    <!-- 挽留弹窗 -->
    <nd-dialog v-model="detentionVisible" :footer="false" class="detention-dialog">
      <div class="detention-dialog-content">
        <div class="detention-title">
          <p>填写简单的信息，最高即可获得</p>
          <p>5万额度！真的要放弃吗？</p>
        </div>

        <ul class="giveup">
          <li v-for="(item, index) in giveUpReason" :key="index" @click="giveUp(index + 1)">
            {{ item }}
          </li>
        </ul>

        <button class="continue" @click="continueApply">
          继续完成，拿额度
        </button>
      </div>
    </nd-dialog>

    <!--自定义键盘-->
    <nd-keyboard ref="keyboard" text="借款" :stepSize="lendingAmountStep" :start-money="startMoney" :visible="keyboardVisible" @changeResult="getKeyboardInput" @step="stepHandler"></nd-keyboard>

    <!-- 广告 -->
    <div class="drawer-container" :class="{ show }" v-if="show && diversionData && diversionData.logo">
      <i class="mask"></i>
      <div class="drawer-content">
        <h3></h3>
        <div class="detail">
          <div class="detail-header">
            <div class="detail-header-title">
              <img :src="diversionData.logo" />
              <div class="pr-info">
                <b>{{ diversionData.productName }}</b>
                <span>{{ diversionData.productDesc }}</span>
              </div>
            </div>
            <nd-button data-sensors-click @click="riverMiddle" class="apply-btn">立即申请 ></nd-button>
          </div>
          <div class="quota-info">
            <div class="configLimit item">
              <span>额度高达 (元)</span>
              <div class="flex-center">
                <div class="bottom-left-money">
                  {{ diversionData.configLimit | currency }}
                </div>
              </div>
            </div>
            <div class="item">
              <div class="bottom-left-label">
                <span>年化利率</span>
                <p>{{ diversionData.minPrice }}%-{{ diversionData.maxPrice }}%</p>
              </div>
            </div>

            <div class="item">
              <div class="bottom-left-label">
                <span>借款期限</span>
                <p>{{ diversionData.minTerms }}-{{ diversionData.terms }}个月</p>
              </div>
            </div>
          </div>
        </div>
        <div class="user-list-swiper">
          <van-swipe class="swiper-container" :vertical="true" :show-indicators="false" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="item in 50" :key="item">
              <span>尾号{{ Math.floor( Math.random() *9000 +1000) }}的用户已成功获取额度{{ diversionData.configLimit - Math.floor( Math.random() *5 +5) * 100 }}元</span>
              <span>{{Math.floor( Math.random() *59 +1)}}分钟前</span>
            </van-swipe-item>
          
          </van-swipe>
        </div>
      </div>
      <div class="next-btn" @click="adGiveUp">放弃申请</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Swipe, SwipeItem } from 'vant'
import { isEmptyObject, setKey, getKey, isTMDMiniprogram } from '../../assets/utils'
import wx from 'weixin-webview-jssdk'
export default {
  name: 'pre-base-authentication',
  components: {
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem
  },

  data () {
    return {
      show: false,
      replenish: [],
      process: '',
      diversionData: {},
      lendingAmountStep: 100,
      keyboardVisible: false,
      productMinLimit: 500,
      productMaxLimit: 500000,
      selectedBankcard: {},
      fundCode: 'NDMICRO',
      backCount: 0,
      hasShow: false,
      loading: false,
      termList: [
        { key: 3, description: '3期' },
        { key: 6, description: '6期' },
        { key: 12, description: '12期' }
      ],
      form: {
        loanAmt: '',
        loanUsage: '',
        loanTerm: '',
        cardText: ''
      },
      isDisabled: true,
      detentionVisible: false,
      agreeProtocol: true,
      pfrom: this.$route.query.pfrom,
      giveUpReason: [
        '放弃免费额度',
        '操作不便，不想继续',
        '手边资料不全，无法完成'
      ],
      popupList: [],
      activityTempleVisible: false,
      winHeight: '',
      needQueue: false,
      applyNo: ''

    }
  },

  computed: {
    submitDisabled () {
      return (
        (this.replenish.includes('loanAmt') && !this.form.loanAmt) ||
        (this.replenish.includes('loanUsage') && !this.form.loanUsage) ||
        (this.replenish.includes('loanTerm') && !this.form.loanTerm) ||
        (this.process === 'CREDIT_BANK_INFO' &&
        (!this.cardText || this.cardText === '去绑卡'))
      )
    },
    // 键盘起始值
    startMoney () {
      return Number(this.form.loanAmt)
    },

    ...mapState({
      dictionary: (state) => state.dictionary || {},
      caseList: (state) => state.caseList
    }),

    ...mapState('user', ['userInfo']),

    ...mapState('authentication', ['baseInfo']),
    cardText () {
      if (this.selectedBankcard.bankCardNo) {
        const code = this.selectedBankcard.bankCardNo.substr(-4, 4)
        return `${this.selectedBankcard.bankName}(${code})`
      } else {
        return `去绑卡`
      }
    }
  },

  async created () {
    // 回显基础信息
    const preBaseInfo = getKey('preBaseInfo') || {}
    this.assetsData(preBaseInfo)

    await Promise.all([
      this.fetchDictionaryX(),
      this.getUserInfo(),
      this.getBankcardList(),
      this.fillProcess()
    ])
    this.getSerialNo()
    this.getPopPr()
    this.$bus.$emit('ready')
  },

  methods: {
    ...mapActions(['fetchDictionaryX', 'getCaseListX']),

    ...mapActions('authentication', [
      'saveBaseInfoX',
      'creditApplyX',
      'getBaseInfoX',
      'cacheBaseInfo',
      'fillProcessX',
      'saveFillInfoX',
      'preCreditPopup'
    ]),

    ...mapActions('user', ['getUserInfoX', 'getLimitX']),
    ...mapActions('bankcard', ['getBankcardListX']),
    adGiveUp () {
      this.show = false
      this.detentionVisible = true
      this.hasShow = true
    },
    // 获取授信号 跳转排队页面 || 结果页
    async getSerialNo () {
      const { success, data } = await this.getLimitX({ loanPlatform: 'TMD' })
      if (success && data.serialNo) {
        this.needQueue = (data.queueStatus === 'PRE_QUEUE')
        this.applyNo = data.serialNo
      }
    },

    toResult () {
      this.$router.replace(
        `/authentication/result?applyNo=${this.applyNo}`
      )
    },
    toWait () {
      this.$router.replace(
        `/authentication/wait?applyNo=${this.applyNo}`
      )
    },
    async fillProcess () {
      const { success, data } = await this.fillProcessX()
      if (success) {
        this.replenish = data.itemList || []
        this.assetsData(data)
        this.process = data.process
      }
    },
    assetsData (data) {
      const { loanAmt, loanTerm, loanUsage } = data
      loanAmt && (this.form.loanAmt = loanAmt)
      loanTerm && (this.form.loanTerm = loanTerm)
      loanUsage && (this.form.loanUsage = loanUsage)
    },
    
    // 获取银行卡列表
    async getBankcardList () {
      const response = await this.getBankcardListX({
        loanPlatform: 'TMD',
        fundCode: this.fundCode,
        productCd: 'TMDP'
      })
      if (response.success && response.data.length > 0) {
        const bank = this.$store.state.bankcard.selectedBankcard
        const defaltBankFilter = response.data.filter((item) => item.defalt)
        const defaltBank =
          defaltBankFilter.length > 0 ? defaltBankFilter[0] : null
        this.selectedBankcard =
          !isEmptyObject(bank) &&
          response.data.filter((item) => item.bankCardNo === bank.bankCardNo)
          .length !== 0
            ? response.data.filter(
              (item) => item.bankCardNo === bank.bankCardNo
            )[0]
            : defaltBank || response.data[response.data.length - 1]
        if (this.selectedBankcard.bankCardNo) {
          this.form.cardText = this.selectedBankcard.bankCardNo
        }
      }
    },

    // 去绑卡
    goBankCard () {
      setKey('preBaseInfo', this.form)
      this.$router.push({
        path: '/bankcard/list',
        query: {
          loanPlatform: 'TMD',
          fundCode: this.fundCode,
          isWxMiniProgramRepay: 'Y'
        }
      })
    },
    // 键盘返回值
    async getKeyboardInput (value) {
      if (value) {
        if (value === 0) {
          this.closeKeyboard()
        } else if (value > 0 && value < this.productMinLimit) {
          this.form.loanAmt = this.productMinLimit
          this.$message(`您当前最小借款金额为${this.productMinLimit}元`)
        } else if (
          value >= this.productMinLimit &&
          value <= this.productMaxLimit
        ) {
          if (value % this.lendingAmountStep === 0) {
            this.form.loanAmt = value
          } else {
            this.form.loanAmt =
              Math.ceil(value / this.lendingAmountStep) *
              this.lendingAmountStep
            this.$message(
              `每笔借款金额必须为${this.lendingAmountStep}的整数倍`
            )
          }
        } else if (value > this.productMaxLimit) {
          this.form.loanAmt = this.productMaxLimit
          this.$message(`您当前最大借款金额为${this.productMaxLimit}元`)
        }
        // if (this.productMaxLimit > value) {
        //   let { success, data } = await this.getMaxLimit({
        //     loanPlatform: 'TMD'
        //   }) // 最大借款金额判断
        //   if (success && data) {
        //     this.tipsVisible = true
        //   }
        // }
      }
      this.closeKeyboard()
      // 最大借款金额判断
    },
    // 关闭键盘
    closeKeyboard () {
      this.stepCount = 0
      this.keyboardVisible = false
    },

    // 点击步长
    stepHandler () {
      this.stepCount++
    },

    // 打开键盘
    openKeyboard () {
      this.$refs.keyboard.init(this.startMoney)
      this.keyboardVisible = true
    },

    // 获取字典
    initDictionary () {
      this.fetchDictionaryX()
    },

    // 获取用户信息
    async getUserInfo () {
      await this.getUserInfoX({ forceUpdate: true, queryType: 'detail' })
    },

    // 提交资料
    submitBaseInfo () {
      this.loading = true
      setTimeout(async () => {
        const { success } = await this.saveFillInfoX({
          ...this.form,
          bankCardNo: this.selectedBankcard.bankCardNo
        })
        if (isTMDMiniprogram()) {
          wx.miniProgram.postMessage({ data: { eventType: 'PROCESS' } })
          wx.miniProgram.navigateBack()
          return
        }
        if (success && this.applyNo) {
          this.needQueue ? this.toWait() : this.toResult()
        }
        this.loading = false
      }, 1500)
    },

    async getPopPr () {
      const { success, data } = await this.preCreditPopup({
        showPosition: 'PRE_CREDIT_REJECT_INFO'
      })
      if (success) {
        this.diversionData = data || {}
      }
    },

    // 放弃激活额度
    giveUp (index) {
      this.$report({
        id: 10083,
        args: {
          target: index
        }
      })
      this.backHome()
      this.detentionVisible = false
      // if (this.pfrom === 'landing') {
      //   this.$router.back()
      // } else {
      //   this.detentionVisible = false
      //   this.$nextTick(() => {
      //     this.$router.push('/')
      //   })
      // }
    },

    // 继续激活额度
    continueApply () {
      this.detentionVisible = false
      this.$report({
        id: 10083,
        args: {
          target: 0
        }
      })
    },
    riverMiddle () {
      this.$sensors.track(
        'Diversion_Click',
        {
          product_type: 'diversion',
          element_positon: 'product_pop',
          product_code: this.diversionData.configId
      })
      this.$router.push({ path: '/river/middle', query: { directionUrl: encodeURIComponent(this.diversionData.directionUrl), ...this.diversionData, from: 'pre-base', applyNo: this.applyNo, needQueue: this.needQueue } })
    },
    // 用户挽留政策
    detention () {
      // 基本信息界面 弹出二次确认框
      this.$report({
        id: 10081
      })
      this.popupList = this.caseList
        .filter(
          (item) =>
            item.showType === 'POPUP' &&
            item.showAction === 'EXIT' &&
            item.step === 'INFO'
        )
        .sort((a, b) => b.sort - a.sort)
      if (this.backCount === 0 && this.diversionData.logo) {
        this.show = true
        this.$sensors.track(
          'Diversion_Exposure', 
          { 
            product_type: 'diversion', 
            element_positon: 'product_pop',
            product_code: this.diversionData.configId
        })
        this.backCount++
      } else {
        this.detentionStep()
      }
    },

    // 开始判断
    detentionStep () {
      if (this.hasShow) {
        this.back(true)
      } else {
        this.hasShow = true
        this.detentionVisible = true
      }
    },
    // 安卓手机键盘弹出和收起时多半都会触发resize事件
    androidWindowResize () {
      var thisHeight = document.documentElement.clientHeight
      if (this.winHeight - thisHeight > 100) {
        this.winHeight = thisHeight
      } else if (this.winHeight - thisHeight < -100) {
        this.winHeight = thisHeight
      }
    }
  },

  watch: {
    computedCondition: {
      handler (val) {
        this.rules.corpName[0].require = val
      }
    },

    detentionVisible (value) {
      this.$report({
        id: 10082,
        args: {
          visible: value ? 1 : 0
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page.base-pre {
  background-color: #f7f7f7;
  padding-bottom: 63px;

  @keyframes curtain {
    to {
      transform: translateY(0);
    }
  }

  @keyframes showAffect {
    to {
      opacity: 1;
    }
  }

  .drawer-container {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 9999;
    top: 0;

    .mask {
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.8);
      opacity: 0;
    }

    .next-btn {
      opacity: 0;
      text-decoration: underline;
      color: #fff;
      position: relative;
      padding: 10px 30px;
      font-size: 24px;
      width: 200px;
      text-align: center;
      margin: 20px auto;
    }

    &.show {
      .drawer-content {
        animation: curtain 2s 0.1s forwards;
      }

      .mask {
        animation: showAffect 0.3s forwards;
      }

      .next-btn {
        animation: showAffect 0.3s 2s forwards;
      }
    }

    .drawer-content {
      width: 750px;
      height: 535px;
      background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
      border-radius: 0px 0px 30px 30px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 110px;
      transform: translateY(-700px);

      .user-list-swiper {
        width: 670px;
        height: 60px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;

        .swiper-container {
          height: 60px;

          .van-swipe-item {
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 30px;
            display: flex;
            justify-content: space-around;
            align-items: center;
          }
        }
      }

      h3 {
        width: 600px;
        height: 42px;
        background: url(./images/drawer/img_title_b@2x.png) no-repeat;
        background-size: 100% 100%;
      }

      .detail {
        width: 670px;
        height: 234px;
        background: #fff;
        padding: 33px 30px;
        margin: 30px auto 20px;
        border-radius: 20px;
        display: flex;
        flex-direction: column;

        .detail-header {
          display: flex;

          .detail-header-title {
            flex: 1;
            display: flex;
            align-items: center;

            img {
              width: 54px;
              height: 54px;
              border-radius: 10px;
            }

            .pr-info {
              flex: 1;
              display: flex;
              flex-direction: column;
              padding-left: 10px;

              b {
                font-size: 28px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
              }

              span {
                font-size: 20px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: #999999;
              }
            }
          }

          .apply-btn {
            width: 190px;
            height: 54px;
            line-height: 54px;
            background: #ffde3d;
            border-radius: 27px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #761212;
          }
        }

        .quota-info {
          display: flex;
          justify-content: space-around;
          padding-top: 30px;

          .item {
            text-align: center;

            span {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
            }

            p {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              padding-top: 5px;
            }

            .bottom-left-money {
              font-size: 40px;
              font-family: DIN-Medium, DIN;
              font-weight: 500;
              color: #333333;
            }
          }
        }
      }

      .button {
        width: 580px;
        height: 135px;
        background: url(./images/drawer/btn_tixian.png) no-repeat;
        background-size: 100% 100%;
        margin-top: -80px;
      }
    }
  }

  .form-cell {
    /deep/.nd-cell-header {
      padding-left: 40px;
      padding-right: 40px;

      .text {
        padding-right: 5px;
        font-size: 28px;
        color: #999;
      }

      .arrow {
        width: 12px;
        height: 20px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: right center;
      }
    }
  }

  .amt-input {
    position: relative;

    &:after {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }

  .title {
    padding: 0 40px;
    margin-top: 44px;

    h1 {
      font-size: 46px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      height: 65px;
      line-height: 65px;
      color: @fc1;
      position: relative;

      img {
        width: 56px;
        position: absolute;
        bottom: 7px;
      }

      span {
        margin-left: 76px;
      }
    }

    h2 {
      margin-top: 17px;
      font-size: 28px;
      line-height: 40px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: @fc3;
    }
  }

  .form {
    min-height: calc(100vh - 800px);

    .card-title {
      height: 45px;
      line-height: 45px;
      margin: 75px 40px 23px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: @fc3;
      position: relative;

      img {
        width: 44px;
        height: 44px;
        position: absolute;
        left: 0;
      }

      span {
        margin-left: 56px;
      }
    }

    .card-panel {
      background-color: white;

      .form-item {
        height: 110px;
        line-height: 110px;
        padding: 0 40px;
        margin-top: 0;

        &.textarea {
          .nd-input {
            margin-top: 40px;
            line-height: 1.4em;
          }
        }

        .nd-select,
        .nd-input,
        .nd-choose,
        .nd-address {
          label {
            font-size: 30px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }

          input {
            font-size: 30px;
          }

          textarea {
            font-size: 30px;
          }
        }

        .nd-input {
          .nd-input-inner {
            line-height: 1.4em;
          }
        }
      }
    }
  }

  .submit-btn {
    margin: 0 auto;
    margin-top: 80px;
  }

  .protocol-container {
    color: @fc3;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 33px;
    text-align: center;
    margin-top: 30px;

    a {
      margin-top: 4px;
      color: #8eb2d8;
    }
  }

  .detention-dialog {
    .detention-title {
      margin: 0 58px;
      text-align: center;
      font-size: 36px;
      line-height: 50px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      padding-bottom: 34px;
      border-bottom: 1px solid #eeeeee;
    }

    .giveup {
      li {
        height: 110px;
        line-height: 110px;
        text-align: center;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: @fc3;
        border-bottom: 1px solid #eeeeee;
      }
    }

    .continue {
      border: 0px solid transparent;
      height: 160px;
      line-height: 160px;
      text-align: center;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: @theme;
      width: 100%;
      -webkit-appearance: none;
      outline: none;
      background-color: #ffffff;
    }
  }

  .activity-dialog {
    .activity-content {
      padding: 0 60px;
      padding-top: 42px;
      padding-bottom: 42px;

      .slogan {
        height: 42px;

        img {
          height: 100%;
          width: unset;
        }
      }

      .text {
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: @fc1;
        font-weight: 400;
        margin-top: 43px;
      }

      p {
        em {
          font-style: normal;
          color: @theme;
        }
      }

      .description {
        width: 500px;
        height: 130px;
        background-color: #fff0f0;
        padding: 29px 0;
        border-radius: 16px;
        margin-top: 100px;
        padding-left: 141px;
        position: relative;

        .desc-image {
          height: 160px;
          width: 116px;
          background-image: url(./images/img_ren@2x.png);
          position: absolute;
          left: 30px;
          bottom: 0px;
          background-size: cover;
        }

        p {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: @fc2;
          line-height: 1.6em;
        }
      }

      .continue-btn {
        width: 440px;
        margin: 0 auto;
        height: 80px;
        line-height: 80px;
        font-size: 36px;
        font-weight: 600;
        margin-top: 70px;
      }

      .giveup-btn {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 40px;
        color: @fc3;
        text-decoration: underline;
        text-align: center;
        margin-top: 22px;
      }
    }

    .activity-template-content {
      width: 620px;
      height: 750px;
      background-size: contain;
      position: relative;

      .button-group {
        position: absolute;
        bottom: 48px;
        left: 50%;
        transform: translateX(-50%);

        .continue-btn {
          width: 440px;
          margin: 0 auto;
          height: 80px;
          line-height: 80px;
          font-size: 36px;
          font-weight: 600;
          margin-top: 70px;
        }

        .giveup-btn {
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 40px;
          color: @fc3;
          text-decoration: underline;
          text-align: center;
          margin-top: 22px;
        }
      }
    }
  }
}

/deep/.new-person-activity {
  .default-content {
    padding-top: 0;
  }
}
</style>